import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "users-table--cell" }
const _hoisted_2 = { class: "users-table--cell-content" }
const _hoisted_3 = { class: "rounded-sm" }

import { IncrediTooltip } from 'incredi-ui';
import { ref, computed } from 'vue';
import { User_AdditionalInfo } from '@/graphql/codegen/generated/graphql';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserFullNameCell',
  props: {
    firstName: null,
    lastName: null
  },
  setup(__props: any) {

const props = __props as {
  firstName: User_AdditionalInfo['firstName'] | null | undefined;
  lastName: User_AdditionalInfo['lastName'] | null | undefined;
}

const tooltip = ref(false);

const handleTooltip = (value: boolean) => {
  tooltip.value = value;
};

const fullNameOverflow = ref();

const isFullNameOverflow = computed(() => fullNameOverflow.value?.scrollWidth > fullNameOverflow.value?.clientWidth);



const firstNameToShow = computed(() => (props.firstName ? props.firstName.charAt(0).toUpperCase() + props.firstName.slice(1).toLocaleLowerCase() : ''));
const lastNameToShow = computed(() => (props.lastName ? props.lastName.charAt(0).toUpperCase() + props.lastName.slice(1).toLocaleLowerCase() : ''));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(IncrediTooltip), {
        direction: "top-middle",
        "model-value": tooltip.value && _unref(isFullNameOverflow),
        delay: 200,
        hover: "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = (value)=>handleTooltip(value))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(firstNameToShow)) + " " + _toDisplayString(_unref(lastNameToShow)), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", {
            ref_key: "fullNameOverflow",
            ref: fullNameOverflow,
            class: "overflow-hidden text-ellipsis"
          }, _toDisplayString(_unref(firstNameToShow)) + " " + _toDisplayString(_unref(lastNameToShow)), 513)
        ]),
        _: 1
      }, 8, ["model-value"])
    ])
  ]))
}
}

})